import { render } from "./ProductWorkorder.vue?vue&type=template&id=512827bf&ts=true"
import script from "./ProductWorkorder.vue?vue&type=script&lang=ts"
export * from "./ProductWorkorder.vue?vue&type=script&lang=ts"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__